import React from 'react';
import Layout from '../../components/layout/layout';
import { WebPageSchema, BreadcrumbSchema } from '../../lib/utils/schema-utils';
import Breadcrumb from '../../components/ui/breadcrumb';


export default function TalentAIPage() {
  return (
    <>
      <WebPageSchema 
        page={{
          title: "Assistant Talent IA | Recruteurs.io",
          description: "Un assistant IA formé pour aider les candidats dans leur recherche d'emploi, basé sur les données emploi par région, poste, salaire et stratégie RH.",
          url: "https://recruteurs.io/talentai",
          lastReviewed: "2025-05-22"
        }}
      />
      
      <BreadcrumbSchema
        items={[
          { name: "Accueil", url: "https://recruteurs.io" },
          { name: "Candidat", url: "https://recruteurs.io/candidat" },
          { name: "Talent AI", url: "https://recruteurs.io/candidat/talentai" }
        ]}
      />

      <Layout
        title="Assistant IA pour les Talents"
        description="Un bot intelligent pour vous guider dans votre recherche d'emploi."
      >
        <section className="py-28 px-6 text-center bg-gradient-to-br from-blue-100 via-pink-100 to-yellow-100">
          <div className="max-w-4xl mx-auto">
 <h1 className="text-4xl md:text-5xl font-bold mb-6 flex justify-center items-center gap-3">
  <span className="text-4xl sm:text-5xl leading-none" style={{ color: 'initial' }}>
    🤖
  </span>
  <span className="bg-gradient-to-r from-pink-500 to-red-500 text-transparent bg-clip-text">
    TalentAI : Votre assistant IA de recherche d'emploi
  </span>
</h1>
            <Breadcrumb 
              items={[
                { name: "Candidat", href: "/candidat" },
                { name: "Talent AI", href: "/candidat/talentai" }
              ]} 
            />
            <p className="text-lg md:text-xl max-w-2xl mx-auto mt-6">
              Posez vos questions à notre assistant IA formé sur les données réelles du marché de l'emploi : offres, salaires, régions, métiers, et stratégies de carrière.
            </p>
          </div>
        </section>

        <section className="py-20 px-6 bg-white min-h-[80vh] flex items-center justify-center">
          <div className="w-full max-w-4xl">
            <iframe
              id="chatbase-full"
              src="https://www.chatbase.co/chatbot-iframe/B-yCETKMIBROl19MyTnEz"
              title="TalentAI Chatbot"
              width="100%"
              height="600"
              className="rounded-xl shadow-xl border border-neutral-200"
              style={{ background: 'white' }}
            />
          </div>
        </section>
      </Layout>
    </>
  );
}